var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "geolocation-component" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "expand overlay-dialog geolocation-dialog",
            persistent: "",
            height: "90%"
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _vm.checkType()
            ? [
                _c(
                  "div",
                  {
                    staticClass: "header",
                    class: {
                      simple:
                        _vm.message.errorCode === 612 ||
                        _vm.errorMsgLocalStorage === "612"
                    }
                  },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "align-center": "" } },
                      [
                        _c("v-flex", [
                          _c("h1", {}, [
                            _vm._v(
                              _vm._s(_vm.$t("Geolocation.ErrorMessage.Header"))
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "geo-content" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { "align-center": "" } },
                      [
                        _c("v-flex", [
                          _c(
                            "div",
                            { staticClass: "troubleshooter-container" },
                            [
                              _vm.message.errorCode &&
                              _vm.message.errorCode !== 612
                                ? _c(
                                    "v-card",
                                    {
                                      staticClass: "troubleshooter-msg",
                                      on: {
                                        scroll: function($event) {
                                          return _vm.handleScroll()
                                        }
                                      }
                                    },
                                    _vm._l(
                                      _vm.geocomplyTroubleshooter,
                                      function(item, index) {
                                        return _c("div", { key: index }, [
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              " " + _vm._s(item.Message) + " "
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            item.HelpLink
                                              ? _c("span", [
                                                  _vm._v(
                                                    "Help:\n                    "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        target: "_blank",
                                                        href: item.HelpLink
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.HelpLink)
                                                      )
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            index !==
                                            _vm.geocomplyTroubleshooter.length -
                                              1
                                              ? _c("i", {
                                                  staticClass: "space-btw"
                                                })
                                              : _vm._e()
                                          ])
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.message.errorCode !== 612 &&
                              !_vm.hasScrolledToBottom &&
                              _vm.geocomplyTroubleshooter.length > 1
                                ? _c("div", { staticClass: "bottom-fade" })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.message.errorCode === 612 ||
                          _vm.message.errorCode === 615
                            ? _c("div", [
                                _vm.message.errorCode === 615
                                  ? _c(
                                      "p",
                                      { staticStyle: { "margin-top": "10px" } },
                                      [
                                        _c("i", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Geolocation.ErrorCode.Note"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.message.errorCode === 612
                            ? _c(
                                "p",
                                {
                                  class: {
                                    simple: _vm.message.errorCode === 612
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Geolocation.ErrorCode." +
                                          _vm.message.errorCode +
                                          "." +
                                          _vm.state
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.message.errorCode === 612
                            ? _c("i", { staticClass: "space-btw" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.message.errorCode === 612
                            ? _c(
                                "p",
                                {
                                  staticClass: "geo-suggestion",
                                  class: {
                                    simple: _vm.message.errorCode === 612
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Geolocation.ErrorCode.suggestion")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.message.errorCode === 612
                            ? _c("i", { staticClass: "space-btw" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.message.errorCode === 612
                            ? _c("p", {
                                staticClass: "simple",
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("Contact.Support"))
                                }
                              })
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "geo-content" }, [
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _vm.message.errorCode === 612
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "download-btn",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.pluginDownload()
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Geolocation.ErrorMessage.DownloadNow"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.retry || _vm.message.errorCode === 612
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "try-again-btn",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.geolocateAgain()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "gc-link" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Geolocation.ErrorMessage.TryAgain")
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.message.errorCode !== 612
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "okay-btn",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.closeDialog()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "gc-link" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("Geolocation.ErrorMessage.OK"))
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.message.errorCode === 612
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "maybe-later-btn",
                              attrs: { block: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.closeDialog()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "gc-link" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Geolocation.ErrorMessage.MaybeLater"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e6fc827", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e6fc827","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/GeolocationTroubleshooter.vue
// module id = null
// module chunks = 